import { MdAdd as AddIcon } from 'react-icons/md';
import { useIntl } from 'react-intl';
import { Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { LocalizationIds } from 'helpers/Localizations';
import { useContext } from 'react';
import { appUserContext } from 'helpers/services';

interface IProps {
    link?: string
    stopPropagation?: boolean
    onClick?: () => void
}

let AddNewButton = ({ link, stopPropagation, onClick }: IProps) => {
    let { formatMessage } = useIntl();
    let { isMobile } = useContext(appUserContext);

    return (
        <>
            {link !== undefined &&
                <Button
                    variant="outlined"
                    component={Link}
                    to={link}
                    onClick={(e: any) => {
                        if (stopPropagation === true)
                            e.stopPropagation();
                    }}
                >
                    <AddIcon />{isMobile === false && <>&nbsp;{formatMessage({ id: LocalizationIds.AddNew })}</>}
                </Button>
            }
            {link === undefined &&
                <Button
                    variant="outlined"
                    onClick={(e) => {
                        if (stopPropagation === true)
                            e.stopPropagation();

                        if (onClick)
                            onClick();
                    }}
                >
                    <AddIcon />{isMobile === false && <>&nbsp;{formatMessage({ id: LocalizationIds.AddNew })}</>}
                </Button>
            }
        </>
    )
}

export default AddNewButton;